export const globalPath = ["/", "/newPassword", "/forgotPassword", "/confirmMail", "/confirmPassword", "/create-new-password"];
